import { SearchResultsSortOptions, Sort } from 'state';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

type Props = {
    searchSort: Sort | undefined,
    onSearchSortChange: (value: Sort) => void
};

const SearchSortFilter = ({ searchSort, onSearchSortChange: onStatusChange }: Props) => (
    <DropDownButton
        items={SearchResultsSortOptions}
        onItemClick={(e) => {
            onStatusChange(e.item === 'Sort by' ? undefined : e.item);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 0);
        }}
        size={'small'}
        fillMode={'solid'}
        rounded={'small'}
        tabIndex={0}
        text={<span>{searchSort?.text}</span>}
    />
);
export default SearchSortFilter;